
import { createStyles, makeStyles, Theme, Grid, Typography } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import {MyListProps} from '../../Interfaces/Interfaces'
import { useHistory, useLocation } from 'react-router-dom';
import Data from '../../classes/Data';
import Table from '../Table/Table';
import { GridRowData } from '@material-ui/data-grid';

const useStyles = makeStyles((theme: Theme) => createStyles({
    wrapper: {
        paddingTop: '2.5rem',
        paddingBottom: '2.5rem',
        minWidth: '80vw',
    }
}));


const List = (props:MyListProps) => {
    const [state, setState] = useState<GridRowData | null>(null);
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const { editTable, editContent, deletableContent, createContent, target, overide, rowsChecked} = props;
    const columns = props.headers;
    const dataObject = useMemo<Data>(() => {
        return new Data(target);
    }, [target])

    useEffect(() => {
        dataObject.GET(setState);
    }, [target, dataObject])

    const actionHandler = (id: number | string): void => {
        if (location.pathname.split('/')[1].toLowerCase() === 'missions') {
            return history.push(`/Mission/${id}/Summary`)
        }
        history.push(`/Campaign/${id}`)
    }

	return (
        <Grid container className={classes.wrapper} justify="center" >
            <Grid item xs={12}>
                <Typography variant="h2" align="center" component="h2">{target.charAt(0).toUpperCase() + target.slice(1)}</Typography>
            </Grid>
            <Grid item xs={10} >
                <Table rowsChecked={rowsChecked} overide={overide} createContent={createContent} deletableContent={deletableContent} dataObject={dataObject} rows={state as any} editContent={editContent} editTable={editTable} columns={columns} action={actionHandler} /*features={tableFeatures}*/ />
            </Grid>
        </Grid>
	)
}
export default List ;

